import DialogGuide from 'global/guides/Dialog'
import { useNavigate } from 'react-router-dom'
import {
    CreateEscalaInput,
    createEscalaSchema,
    escalas,
} from 'service/api/endpoints/escalas'
import { toast } from 'sonner'
import FormularioEscala from '../forms/Forms'

function AdicionarEscalaModal() {
    const navigate = useNavigate()
    const { isLoading, mutate } = escalas.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleSubmit = (data: CreateEscalaInput) =>
        mutate(data, {
            onSuccess: () => {
                toast.success('Escala adicionada com sucesso!')

                navigate(-1)
            },
            onError: ({ statusCode, message }) => {
                if (statusCode === 400) {
                    toast.error(message)
                } else {
                    toast.error('Erro ao adicionar escala!')
                }
            },
        })

    return (
        <DialogGuide.Root
            schema={createEscalaSchema}
            defaultValues={{ emHoras: true }}
            height="auto"
            width="40rem"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <DialogGuide.Title>Adicionar Escala</DialogGuide.Title>
            <DialogGuide.Content dividers>
                <FormularioEscala />
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Fechar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton>
                    Adicionar
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

export default AdicionarEscalaModal
